import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CircleSlashIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM12 4.98C10.42 4.98 8.96 5.52 7.78 6.44L17.52 16.18C18.4 15 18.94 13.54 18.94 11.96C18.94 8.14 15.8 4.98 12 4.98ZM5.06 11.96C5.06 15.78 8.2 18.94 12 18.94C13.58 18.94 15.04 18.4 16.22 17.48L6.48 7.74C5.6 8.92 5.06 10.38 5.06 11.96Z" />
    </SvgIcon>
  );
});
